import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material';
import { Component, ViewChild, TemplateRef } from '@angular/core';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
@Component({
    selector: "page-claveunica",
    templateUrl: "./claveunica.component.html",
    providers: [ClaveUnicaService]
})

export class ClaveUnicaComponent {

    public url;
    @ViewChild('openModal') openModal:TemplateRef<any>;

    constructor(private _claveUnicaService: ClaveUnicaService, private dialog: MatDialog, private sanitizer: DomSanitizer){


    }
}